// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduleTab {
    height: 100%;
    overflow-y: auto;
    padding-top: 10px;
    /* Hide scrollbar for webkit browsers */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
}

.scheduleTab::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

.scheduleTab_list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.scheduleTab_header {
    margin-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
}

.scheduleTab_header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.scheduleTab_item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 15px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.scheduleTab_item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-color: #4CAF50;
}

.scheduleTab_item--clickable {
    cursor: pointer;
}

.scheduleTab_item_avatar {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    flex-shrink: 0;
    background-color: #e0e0e0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.scheduleTab_item_info {
    flex: 1;
    min-width: 0;
}

.scheduleTab_item_mainInfo {
    display: flex;
    align-items: center;
    gap: 8px;
}

.scheduleTab_item_clientName {
    font-size: 14px;
    font-weight: 500;
    color: #333;
}

.scheduleTab_item_sessionDate {
    font-size: 12px;
    color: #999;
}

.scheduleTab_item_actions {
    margin-left: 15px;
}

.scheduleTab_watchButton {
    display: flex;
    align-items: center;
    justify-content: center;
}

.scheduleTab_noAnalysis {
    color: #999;
    font-size: 12px;
    font-style: italic;
}



.scheduleTab_empty {
    text-align: center;
    color: #999;
    padding: 40px 20px;
    font-style: italic;
}

.scheduleTab_empty {
    text-align: center;
    padding: 40px;
    color: #999;
    font-size: 16px;
}

.scheduleTab_loadMoreButton {
    background: none;
    border: none;
    color: #999;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
    padding: 8px 0;
    transition: color 0.2s ease;
}

.scheduleTab_loadMoreButton:hover {
    color: #666;
}

.scheduleTab_loadMoreButton:disabled {
    color: #ccc;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/scheduleTab/ScheduleTab.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;IACvC,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,gBAAgB;AAC9C;;AAEA;IACI,aAAa,EAAE,0BAA0B;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".scheduleTab {\n    height: 100%;\n    overflow-y: auto;\n    padding-top: 10px;\n    /* Hide scrollbar for webkit browsers */\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n}\n\n.scheduleTab::-webkit-scrollbar {\n    display: none; /* Chrome, Safari, Opera */\n}\n\n.scheduleTab_list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.scheduleTab_header {\n    margin-bottom: 20px;\n    border-bottom: 1px solid #e0e0e0;\n    padding-bottom: 10px;\n}\n\n.scheduleTab_header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.scheduleTab_item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 15px;\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.scheduleTab_item:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    border-color: #4CAF50;\n}\n\n.scheduleTab_item--clickable {\n    cursor: pointer;\n}\n\n.scheduleTab_item_avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-color: #e0e0e0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.scheduleTab_item_info {\n    flex: 1;\n    min-width: 0;\n}\n\n.scheduleTab_item_mainInfo {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.scheduleTab_item_clientName {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n}\n\n.scheduleTab_item_sessionDate {\n    font-size: 12px;\n    color: #999;\n}\n\n.scheduleTab_item_actions {\n    margin-left: 15px;\n}\n\n.scheduleTab_watchButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scheduleTab_noAnalysis {\n    color: #999;\n    font-size: 12px;\n    font-style: italic;\n}\n\n\n\n.scheduleTab_empty {\n    text-align: center;\n    color: #999;\n    padding: 40px 20px;\n    font-style: italic;\n}\n\n.scheduleTab_empty {\n    text-align: center;\n    padding: 40px;\n    color: #999;\n    font-size: 16px;\n}\n\n.scheduleTab_loadMoreButton {\n    background: none;\n    border: none;\n    color: #999;\n    font-size: 14px;\n    text-decoration: underline;\n    cursor: pointer;\n    padding: 8px 0;\n    transition: color 0.2s ease;\n}\n\n.scheduleTab_loadMoreButton:hover {\n    color: #666;\n}\n\n.scheduleTab_loadMoreButton:disabled {\n    color: #ccc;\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
